import React from 'react';
import { formatCurrency } from "../../../../../../../../helpers/format";
import Chips from '../../../../../../ChipBalance/Chips';

export const getTournamentBuyinInfo = data => {
    const { currency, buyin, fee, payWallets } = data.buyIn;
    const allowPaymentMain = ['allowFPP', 'forbidFPP'].includes(payWallets);
    const allowPaymentFPP = ['onlyFPP', 'allowFPP'].includes(payWallets);
    const fppRate = 100;
    const buyinMain = buyin + fee
    const buyinFPP = Math.round(buyinMain * fppRate)

    const formatForMainBuyin = formatCurrency(buyinMain, 'eng', currency);

    const chipValue = (obj = {}) => <Chips margin={obj.margin || 2} val={obj.val || buyinMain} />;

    return {
        // guaranteed: `${formatCurrency(guaranteedValue, 'eng', guaranteedCurrency)} Guaranteed - Rebuy`,
        limit: `${data.numberOfSpins} Spin Limit Scheduled Tournament`,
        name: data.tournamentName,
        allowPaymentMain, allowPaymentFPP, currency, chipValue, buyinMain, buyinFPP
    }
}